// En-tête standard des pages de la section Pilotage.
// Tokens : carte blanche rounded-2xl, fine barre gradient bleu→cyan, pastille
// d'icône gradient (même langage que la sidebar et les onglets actifs),
// label uppercase + titre + sous-titre, chips stats et slot action à droite.

const NIVEAU_BADGES = {
    '6': 'bg-blue-100 text-blue-700 border-blue-200',
    '5': 'bg-violet-100 text-violet-700 border-violet-200',
    '4': 'bg-emerald-100 text-emerald-700 border-emerald-200',
    '3': 'bg-rose-100 text-rose-700 border-rose-200',
};

function PilotageHeader({ icone: Icone, label = "Pilotage", titre, sousTitre, stats, action, badgeNiveau }) {
    const niveau = badgeNiveau ? String(badgeNiveau)[0] : null;
    const badgeClasses = niveau ? NIVEAU_BADGES[niveau] : null;

    return (
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden mb-4">
            <div className="h-1 bg-gradient-to-r from-blue-600 to-cyan-500" />
            <div className="px-5 py-4 flex items-center justify-between gap-4 flex-wrap">
                <div className="flex items-center gap-3 min-w-0">
                    {Icone && (
                        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center shadow-md shadow-blue-500/30 shrink-0">
                            <Icone className="w-5 h-5 text-white" />
                        </div>
                    )}
                    <div className="min-w-0">
                        <span className="text-[11px] font-bold tracking-widest text-slate-400 uppercase">{label}</span>
                        <div className="flex items-center gap-2 flex-wrap">
                            <h1 className="text-xl font-extrabold text-slate-800 leading-tight truncate">{titre}</h1>
                            {badgeClasses && (
                                <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full border ${badgeClasses}`}>
                                    {niveau}e
                                </span>
                            )}
                        </div>
                        {sousTitre ? <p className="text-sm text-slate-500 truncate">{sousTitre}</p> : null}
                    </div>
                </div>

                {(stats?.length > 0 || action) && (
                    <div className="flex items-center gap-2.5 flex-wrap">
                        {stats?.map(({ label: statLabel, valeur }) => (
                            <div key={statLabel} className="bg-slate-50 border border-slate-200 rounded-xl px-3 py-2 text-center">
                                <p className="text-[10px] uppercase tracking-wider text-slate-400 font-semibold">{statLabel}</p>
                                <p className="text-xl font-extrabold text-slate-800 leading-tight">{valeur}</p>
                            </div>
                        ))}
                        {action}
                    </div>
                )}
            </div>
        </div>
    );
}

export default PilotageHeader;
